.grid {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 18rem), 1fr));
}

.grid > li,
.grid > li > * {
  height: 100%;
}

.card {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 1.6rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: var(--bg-elev);
  transition: border-color 200ms ease, transform 200ms ease, background-color 200ms ease;
}

.card[data-linked]:hover {
  border-color: var(--accent);
  background: var(--bg-elev-2);
  transform: translateY(-3px);
}

.icon {
  display: grid;
  place-items: center;
  width: 2.5rem;
  height: 2.5rem;
  margin-bottom: 1.1rem;
  border-radius: var(--radius-sm);
  background: var(--accent-quiet);
  color: var(--accent);
}

.title {
  font-size: var(--step-1);
  font-weight: 600;
  letter-spacing: -0.01em;
  margin-bottom: 0.55rem;
}

.link {
  color: var(--text);
  text-decoration: none;
}

.link:hover {
  color: var(--accent);
}

/* Stretch the link's hit area over the whole card without nesting it. */
.link::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
}

.blurb {
  flex: 1;
  color: var(--text-dim);
  font-size: var(--step--1);
  line-height: 1.7;
}

.cta {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  margin-top: 1.25rem;
  color: var(--accent);
  font-family: var(--font-mono);
  font-size: 0.74rem;
  letter-spacing: 0.02em;
}
